import { Alert, AlertTitle, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { type ICommercialImportStatusItem } from "../types";
import { format, isValid } from "date-fns";

interface Props {
  importStatuses: ICommercialImportStatusItem[];
}

const formatDateSafely = (
  dateString: string | null | undefined,
  formatStr: string
): string => {
  if (dateString == null) return "-";
  const date = new Date(dateString);
  if (!isValid(date)) return "-";
  return format(date, formatStr);
};

const CommercialImportStatus: React.FC<Props> = ({ importStatuses }) => {
  return (
    <Alert severity="info">
      <AlertTitle sx={{ fontWeight: "bold" }}>更新情報</AlertTitle>
      <Box style={{ maxHeight: "6.5em", overflow: "auto" }}>
        <Grid container spacing={2}>
          {importStatuses.map((item, index) => (
            <Grid
              item
              key={`${item.legalAffairsBureauId}-${item.importDate}-${item.legalAffairsBureauRequestMonth}-${index}`}
            >
              ● {formatDateSafely(item.importDate, "yyyy/MM/dd")}
              <Typography sx={{ fontWeight: "bold", mx: 0.5 }} display="inline">
                {item.prefecturesName} - {item.legalAffairsBureauName}
                {formatDateSafely(
                  item.legalAffairsBureauRequestMonth,
                  "yyyy/MM"
                )}
              </Typography>
              公開
            </Grid>
          ))}
        </Grid>
      </Box>
    </Alert>
  );
};

export { CommercialImportStatus };
